import { FETCH_PROMOTIONS_SUCCESS, FETCH_PROMOTIONS_ERROR } from '../constants/ActionTypes'
import { ResponseError } from '@ynap/api-utils'
import type GenericAction from './types/genericAction.types'

const initialState: State = {
    promotions: [],
    isLoadingPromotions: undefined,
    error: undefined,
}

type Description = {
    longDescription: string
    shortDescription: string
}

type Promotion = {
    id: string
    name: string
    description: Description[]
}

type State = {
    promotions: Promotion[]
    isLoadingPromotions?: boolean
    error?: ResponseError
}

export type ActivePromotionsAction = GenericAction<typeof FETCH_PROMOTIONS_ERROR | typeof FETCH_PROMOTIONS_SUCCESS, { payload: Promotion[] | ResponseError }>

const activePromotions = (state: State = initialState, action: ActivePromotionsAction) => {
    switch (action.type) {
        case FETCH_PROMOTIONS_SUCCESS: {
            const { payload = [] } = action
            return { promotions: payload, isLoadingPromotions: false }
        }
        case FETCH_PROMOTIONS_ERROR: {
            const { payload = [] } = action
            return { error: payload, isLoadingPromotions: false }
        }
        default:
            return state
    }
}

export default activePromotions
